import { render, staticRenderFns } from "./ebc-btn.vue?vue&type=template&id=2c65292e&scoped=true"
import script from "./ebc-btn.vue?vue&type=script&lang=js"
export * from "./ebc-btn.vue?vue&type=script&lang=js"
import style0 from "./ebc-btn.vue?vue&type=style&index=0&id=2c65292e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c65292e",
  null
  
)

export default component.exports